import { Section } from "../../components/Section";
import ComparisonGrid from "../../components/comparison/ComparisonGrid";

export default function Comparativo() {
  return (
    <Section>
      <div className="container">
        <ComparisonGrid />
      </div>
    </Section>
  );
}
